export { default } from "./PressCoverageItem";
